import { useRef, type PropsWithChildren } from 'react';

import { CenterSlot, Header, LeftSlot, RightSlot, SubHead } from './styles';
import type { MarketDataCardHeaderProps } from './types';

export const MarketDataCardHeader = ({
  children,
  className,
  isDraggable,
  slotFlexRule,
  bottomCenterItems,
  topCenterItems,
  topSubheader,
  topLeftItems,
  topRightItems,
}: PropsWithChildren<MarketDataCardHeaderProps>) => {
  const bottomCenterItemsRef = useRef<HTMLDivElement | null>(null);
  const topCenterItemsRef = useRef<HTMLDivElement | null>(null);
  const topLeftItemsRef = useRef<HTMLDivElement | null>(null);
  const topRightItemsRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <Header className={className} isDraggable={!!isDraggable}>
        {topLeftItems || slotFlexRule ? (
          <LeftSlot ref={topLeftItemsRef} flex={slotFlexRule}>
            {topLeftItems}
          </LeftSlot>
        ) : null}
        {topCenterItems && (
          <CenterSlot data-testid="top-center-slot" ref={topCenterItemsRef}>
            {topCenterItems}
          </CenterSlot>
        )}
        {topRightItems && (
          <RightSlot ref={topRightItemsRef} flex={slotFlexRule}>
            {topRightItems}
          </RightSlot>
        )}
      </Header>
      <SubHead>{topSubheader}</SubHead>
      {children}
      {bottomCenterItems && (
        <CenterSlot
          ref={bottomCenterItemsRef}
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          flexBasis="100%"
        >
          {bottomCenterItems}
        </CenterSlot>
      )}
    </>
  );
};
